import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import validations_es from 'translations/es/validations.json';
import validations_en from 'translations/en/validations.json';
import validations_pt from 'translations/pt/validations.json';
import validations_de from 'translations/de/validations.json';
import glossary_es from 'translations/es/glossary.json';
import glossary_en from 'translations/en/glossary.json';
import glossary_pt from 'translations/pt/glossary.json';
import glossary_de from 'translations/de/glossary.json';
import common_es from 'translations/es/common.json';
import common_en from 'translations/en/common.json';
import common_pt from 'translations/pt/common.json';
import common_de from 'translations/de/common.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            es: {
                translation: common_es,
                validations: validations_es,
                glossary: glossary_es
            },
            en: {
                translation: common_en,
                validations: validations_en,
                glossary: glossary_en
            },
            pt: {
                translation: common_pt,
                validations: validations_pt,
                glossary: glossary_pt
            },
            de: {
                translation: common_de,
                validations: validations_de,
                glossary: glossary_de
            },
        },
        debug: false,
        ns: ['translation', 'validations', 'glossary'],
        defaultNS: 'translation',
        fallbackLng: 'en',
        lng: 'es',
        interpolation: {
            escapeValue: false,
            format: (value, format, lng) => {
                if (format === 'uppercase') return value.toUpperCase();
                if (format === 'lowercase') return value.toLowerCase();
                // if(value instanceof Date) return moment(value).format(format);
                return value;
            }
        }
    });

export default i18n;